import type { FaireProductEntity } from "../../entity_types/product";

export const p_dtzqx7s2qd: FaireProductEntity = {
  token: "p_dtzqx7s2qd",
  type: "product",
  name: "Isle of Dreams Candle | Agave Nectar, Citrus, & Peach",
  brandToken: "b_tthhaz7z5x",
  brandName: "Jungle Club",
  imageUrl:
    "https://cdn.faire.com/fastly/453e5e176174f103c86d4f4f4ccd1c748d87f47e5fd72ab7ec456f793967e9e9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/64de5c81661cd1d9248fdf6ba69cd5c1767269277c226bd4cd6428e6ae830186.jpeg",
    "https://cdn.faire.com/fastly/efb3c1cb94223c313b7643ac5d38b601ebed61d4a21852ee3c7f4a83f633f5d1.jpeg",
    "https://cdn.faire.com/fastly/e48edfb75919a8685eaf13792640e9f89bbaa4062de97fa88228c9ee3bf94df7.jpeg",
    "https://cdn.faire.com/fastly/23d7ded7cf365c59178ff05b1e129ef3deb853fa98113a0ab4b8ce4b86553a41.jpeg",
  ],
  priceDollars: 15,
  description:
    "Escape to paradise with the Isle of Dreams Candle, elegantly crafted in a creamy vanilla ceramic vessel. Hand-poured in sunny San Diego, it features a delightful scent blend of agave nectar, citrus, and peach, creating a refreshing and uplifting aroma.\n\nWith premium fragrance and a paraffin-free coconut soy wax for a clean burn, this non-toxic candle adds a touch of adventure to any space. Adorned with a fierce cheetah and palm tree, it inspires relaxation and daydreams. Perfect for self-care or as a thoughtful gift, the Isle of Dreams Candle is your ticket to tranquility.\n\n• Cork Lid\n• Scent | Agave Nectar, Citrus & Peach\n• Size | 10 Ounces\n• Ceramic Vessel Imported\n• Designed and Poured in the USA",
  tags: [],
  msrpDollars: 29.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T19:41:50.429Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
